import { Route } from 'react-router-dom';
import { LoginPage } from '../pages/LoginPage';
import { ResetPasswordPage } from '../pages/ResetPasswordPage';

export const authRoutes = [
  <Route key="login" path="/auth/login" element={<LoginPage />} />,
  <Route key="reset-password" path="/reset-password" element={<ResetPasswordPage />} />,
];